import axios from 'axios'
import swal from 'sweetalert'
// import { ErrorTypes } from 'vue-router'

class CustomerFactory {
  async bill(data: any) {
    try {
      const url = '/customers/bill-users'
      const response = await axios.get(url, {
        params: {
          school_year_id: data.school_year_id,
          order_at: data.order_at
        }
      })
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async detailBill(id: any) {
    try {
      const url = `/customers/bill-users/${id}`
      const response = await axios.get(url)
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async checkoutOrder(data: any) {
    try {
      const url = '/customers/orders'
      const response = await axios.post(url, data)
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        const messages: Array<string> = error.response.data.messages
        swal(messages.join(', '), '', 'error')
      }
      return false
    }
  }

  async listOrder(data: any) {
    try {
      const url = '/customers/orders'
      const response = await axios.get(url, {
        params: {
          status: data.status,
          date_from: data.date_from,
          date_to: data.date_to,
          keyword: data.keyword,
          offset: data.offset,
          limit: data.limit,
          order_by: data.order_by,
          order_at: data.order_at
        }
      })
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async detailOrder(order_id: any) {
    try {
      const url = `/customers/orders/${order_id}`
      const response = await axios.get(url)
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async calcConvenienceFee(data: any) {
    try {
      const url = '/customers/convenience_fee'
      const response = await axios.post(url, data)
      return response.data
    } catch (error) {
      console.error(error)
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return false
    }
  }

  async getCustomInvoice(order_id: any) {
    try {
      const url = `/customers/orders/${order_id}/invoice`
      const response = await axios.get(url)
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async uploadReference(order_id: any, file: File) {
    try {
      const url = `/customers/orders/${order_id}/reference`
      const formData = new FormData()
      formData.append('file', file)
      const response = await axios.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }
  async getRefundDetails(bill_user_id: any) {
    try {
      const url = `/customers/bill-users/${bill_user_id}/refund-details`
      const response = await axios.get(url)
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }
}

export const customerFactory = new CustomerFactory()
